<template>
  <div
    v-if="isCommitted"
    @click="toggleModal"
  >
    <HoverTooltip
      ref="hoverTooltip"
      :position="position"
      :disabled="tooltipDisabled"
    >
      <template #subject>
        <div
          data-test-id="pill"
          :style="{ paddingLeft: showCollege ? '0.125rem' : '0.5rem' }"
          style="padding-top: 0.125rem; padding-bottom: 0.125rem;"
          class="flex justify-center items-center content-center rounded-full select-none pr-2 bg-blue-300"
          :class="{'cursor-pointer': showCursorPointer }"
        >
          <div
            v-if="commitmentSchoolImage && showCollege"
            class="w-4 h-4 md:w-6 md:h-6 rounded-full mr-1 bg-white flex justify-center items-center"
            :style="{padding: isMobile ? '3px' : '4px'}"
          >
            <img
              :src="commitmentSchoolImage"
              alt="College image"
              class="w-full h-full"
              data-test-id="college-image"
            />
          </div>
          <div
            v-else-if="showCollege"
            class="w-4 h-4 md:w-6 md:h-6 rounded-full mr-1 bg-violet-300 flex justify-center items-center content-center font-medium"
            style="padding: 0.5rem;"
          >
            <Icon name="college" :style="{fontSize: isMobile ? '12px' : '16px'}" color="white" />
          </div>
          <span
            class="text-white ds-text-2xs md:ds-text-xs"
            :style="{
              paddingTop: !showCollege && !isMobile ? '0.25rem' : '0',
              paddingBottom: !showCollege && !isMobile ? '0.25rem' : '0',
              paddingLeft: !showCollege && !isMobile ? '0.125rem' : '0',
              paddingRight: !showCollege && !isMobile ? '0.125rem' : '0',
            }"
          >Committed</span>
        </div>
      </template>
      <template #tooltip>
        <p
          class="ds-text-xs"
        >
          Committed<span
            v-if="commitmentSchoolName"
            class="font-semibold"
            data-test-id="school"
          > to {{ commitmentSchoolName }}</span><span
            v-if="commitmentDate"
            class="font-semibold"
            data-test-id="date"
          > {{ commitmentDateText }}</span>
        </p>
      </template>
    </HoverTooltip>
    <PModal
      ref="collegeModal"
      :show="showModal"
      bg-color="bg-gray-100"
      @close="toggleModal"
    >
      <template #body>
        <div
          :style="{height: isMobile ? '85dvh' : '100%'}"
          class="flex flex-col justify-between items-center w-full -mb-16 md:mb-0 bg-gray-100"
          data-test-id="modal-body"
        >
          <div class="pb-4 px-0 w-full flex flex-col items-center text-center">
            <div class="p-4 bg-white rounded-md w-full flex items-center justify-center">
              <img
                v-if="commitmentSchoolImage"
                :src="commitmentSchoolImage"
                alt="College image"
                class="w-24 h-24"
                data-test-id="modal-school-image"
              />
              <div v-else class="w-32 h-32 rounded-full flex justify-center bg-violet-300 items-center content-center">
                <Icon name="college" style="font-size: 94px" color="white" />
              </div>
            </div>
            <p class="ds-text-base font-semibold text-gray-900 mt-4">
              Committed to <a
                :href="`/program/${commitmentSchoolUrl}`"
                class="color-blue-300"
              >{{ commitmentSchoolName }}</a>
            </p>
            <p
              v-if="commitmentSchoolLocation"
              class="ds-text-sm font-semibold text-gray-700 mt-1"
              data-test-id="modal-school-location"
            >
              {{ commitmentSchoolLocation }}
              <span v-if="commitmentSchoolDivision"> • {{ commitmentSchoolDivision }}</span>
              <span v-if="commitmentSchoolConference"> – {{ commitmentSchoolConference }}</span>
            </p>
          </div>
          <div
            v-if="commitmentDate"
            class="text-center p-0 md:pt-4 border-0 border-solid border-gray-300 md:border-t-2 w-full"
          >
            <p class="ds-text-sm font-medium text-gray-500" data-test-id="modal-commitment-date">
              Logged commitment {{ commitmentDateText }}
            </p>
          </div>
        </div>
      </template>
    </PModal>
  </div>
</template>

<script>
import { HoverTooltip, Icon, PModal } from "@sportsrecruits/playbook"
import { mapGetters } from "vuex";

export default {
  name: "CommittedPill",
  components: {
    HoverTooltip,
    Icon,
    PModal,
  },
  props: {
    position: {
      type: String,
      default: "top",
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapGetters(
      "athleteProfile",
      [
        "isCommitted",
        "commitmentSchoolName",
        "commitmentSchoolImage",
        "commitmentDate",
        "commitmentSchoolLocation",
        "commitmentSchoolDivision",
        "commitmentSchoolConference",
        "commitmentSchoolUrl",
      ],
    ),
    showCollege() {
      return !!(this.commitmentSchoolName && this.commitmentSchoolUrl)
    },
    isMobile() {
      return ["xs", "sm", "mobile"].includes(this.$mq);
    },
    tooltipDisabled() {
      if (this.isMobile) {
        return !(this.commitmentDate && !this.commitmentSchoolName);
      }
      return !(this.commitmentDate || this.commitmentSchoolName);
    },
    showCursorPointer() {
      return this.commitmentDate || this.commitmentSchoolName;
    },
    commitmentDateText() {
      const today = new Date().toLocaleDateString("en-US");
      return this.commitmentDate === today ? 'today' : `on ${this.commitmentDate}`;
    },
  },
  methods: {
    toggleModal() {
      this.showModal = !!(!this.showModal && this.showCollege);
    },
  },
}
</script>

